import React from 'react';

import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';
import {
    SelectEmailType,
} from 'src/modules/profile/user/tabs/user-login/sections/send-welcome-email/select-email-type.component';

import {Group} from '@pb/kit-component-group';


import {SendWelcomeEmailSectionSkeleton} from './select-email-type-block.skeleton';

import type {AccountInfo} from 'src/openapi/admin/models/AccountInfo';
import type {AccountManagerInfo} from 'src/openapi/admin/models/AccountManagerInfo';
import type {EmailType} from 'src/openapi/admin/models/EmailType';
import type {Error} from 'src/openapi/admin/models/Error';
import type {SsoSettings} from 'src/use-cases/account/useGetAccountSSOSettings';

type Props = {
    isLoading: boolean,
    loadingError: Error | null,
    teamMembers: AccountManagerInfo[],
    accountInfo: AccountInfo | null,
    ssoSettings: SsoSettings,
    emailType: EmailType | null,
    setEmailType: (emailType: EmailType | null) => void,
};

export const SelectEmailTypeBlock = (props: Props) => {
    const {
        isLoading,
        loadingError,
        emailType,
        setEmailType,
        teamMembers,
        accountInfo,
        ssoSettings,
    } = props;

    return (
        <Skeleton shown={isLoading} view={<SendWelcomeEmailSectionSkeleton/>}>
            <ServerResponseHandler serverError={loadingError} smallView={true}>
                <Group direction="v">
                    <SelectEmailType
                        emailType={emailType}
                        setEmailType={setEmailType}
                        teamMembers={teamMembers}
                        accountInfo={accountInfo}
                        ssoSettings={ssoSettings}
                        disabled={false}
                    />
                </Group>
            </ServerResponseHandler>
        </Skeleton>
    );
};
